<template>
    <div class="tw-rounded tw-overflow-auto tw-border tw-border-solid tw-border-gray-100">
        <table class="tw-min-w-full tw-leading-normal">
            <thead class="">
                <tr>
                    <th 
                        class="tw-px-1x tw-w-[45px] last:tw-border-e-0 tw-border-e tw-py-1 tw-border-b tw-borderx tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-text-[10px] tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider">
                        <div class="tw-m-autox tw-w-full tw-flex tw-items-center tw-justify-center">
                            <label class="tw-flex tw-items-center tw-cursor-pointer tw-space-x-2x">
                                <input type="checkbox" class="tw-hidden tw-peer" v-model="allSelected" />
                                <div
                                class="tw-w-5 tw-h-5 tw-bg-white tw-rounded tw-border tw-border-gray-300 tw-flex tw-items-center tw-justify-center tw-transition tw-duration-200 peer-checked:tw-bg-primary-500 peer-checked:tw-border-primary-500 peer-focus:tw-ring-2 peer-focus:tw-ring-primary-500">
                                <icon icon="mdi:check" class="tw-w-4 tw-h-4 tw-text-white " :class="[allSelected ? 'tw-block' : 'tw-hidden']" />
                                </div>
                            </label>
                        </div>
                    </th>
                    <th v-for="c in columns" :key="c.name" :class="c.classes"
                        class="tw-px-5 last:tw-border-e-0 tw-border-e tw-py-3 tw-border-b tw-borderx tw-border-gray-100 tw-bg-gray-50 tw-text-start tw-text-[10px] tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider">
                        <span>{{ $t(c.label) }}</span>

                    </th>
                </tr>
            </thead>

            <tbody v-if="props.loading">
                <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50"
                    v-for="i in 10" :key="i">
                    <td v-for="c in columns" :key="c.name" class="tw-px-2 tw-py-3">
                        <div
                            class="tw-w-full tw-py-3 tw-bg-gray-50 group-even:tw-bg-white  tw-rounded tw-min-w-[30px] tw-animate-pulse">

                        </div>
                    </td>
                </tr>
            </tbody>


            <tbody v-else>
                <template v-if="items.length > 0">
                    <UserTableRow v-for="item in items" :key="item.id + item.updated_at" :item="item" />
                </template>
                <template v-else>
                    <tr>
                        <td :colspan="columns.length">
                            <div
                                class="tw-p-5 tw-bg-white tw-min-h-[250px]  tw-text-gray-600 tw-flex tw-items-center tw-justify-center tw-text-lg">
                                <p>{{ $t('messages.table-no-results') }}</p>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

    </div>

    <div class="tw-my-4"></div>

    <TablePagination v-if="items.length > 0" :has-next="!!options.next_page_url" :has-previous="!!options.prev_page_url" @previous="emit('previous')" @next="emit('next')" />
</template>

<script setup>
import { ref, defineProps, toRef, defineEmits, inject, computed } from 'vue'
import TablePagination from '@/components/table/TablePagination'
import UserTableRow from './UserTableRow'

const props = defineProps(['loading', 'data', 'items', 'options']);
const items = toRef(props, 'items')
const emit = defineEmits(['next', 'previous'])
const allSelected = computed({
    get: () => items.value.length ? items.value.every(item => selected.value.includes(item.id)) : false,
    set: (value) => {
        if (value) {
            selected.value = items.value.map(i => i.id)
        } else {
            selected.value = []
        }
    }
})
const selected = inject('selected');

const columns = ref([
    // { name: 'checkbox', label: '', classes: ['tw-w-[30px] tw-whitespace-nowrap'] },
    { name: 'id', label: 'fields.id', classes: ['tw-w-[30px] tw-whitespace-nowrap'] },
    { name: 'name', label: 'fields.name', classes: [] },
    { name: 'goal', label: 'fields.goal', classes: ['tw-w-[120px] tw-whitespace-nowrap'] },
    { name: 'progress', label: 'fields.progress', classes: ['tw-w-[150px] tw-whitespace-nowrap'] },
    { name: 'status', label: 'fields.status', classes: ['tw-w-[50px] tw-whitespace-nowrap'] },
    { name: 'last_login_at', label: 'fields.last_login_at', classes: ['tw-w-[150px] tw-whitespace-nowrap'] },
    { name: 'login_times', label: 'fields.login_times', classes: ['tw-w-[150px] tw-whitespace-nowrap'] },
    { name: 'last_action_at', label: 'fields.last_action_at', classes: ['tw-w-[100px] tw-whitespace-nowrap'] },
    { name: 'actions', label: 'fields.actions', classes: ['tw-w-[100px] tw-whitespace-nowrap'] },
])
</script>

<style></style>